import React from 'react';
import { ADA_MARK_PATHS } from './brand';

export default function AdaMark({ className = '', style }) {
  return (
    <svg
      className={`ada-mark ${className}`}
      style={style}
      viewBox="0 0 72 72"
      aria-hidden="true"
      focusable="false"
    >
      {ADA_MARK_PATHS.map((d) => (
        <path key={d} fillRule="evenodd" d={d} />
      ))}
    </svg>
  );
}
